import React from 'react';
import cn from 'classnames';
import styles from './timePicker.module.scss'
import upArrowButton from '@assets/images/KDSICONS/upArrowButton.svg'
import upArrowButtonDisabled from '@assets/images/KDSICONS/upArrowButtonDisabled.svg'
import downArrowButton from '@assets/images/KDSICONS/downArrowButton.svg'
import downArrowButtonDisabled from '@assets/images/KDSICONS/downArrowButtonDisabled.svg'
import timerColon from '@assets/images/KDSICONS/timerColon.svg';

const TimeInputBox = ({type, disabled, handleTimeChange, time})=>{
    const prefix = time < 10 && time >= 0;
    const disableButton = (pos) => {
      if(pos === 'increment'){
        return type === "hh" ? time === 24 : time === 59;
      }
      else if(pos === 'decrement'){
        return time === 0;
      }
      return false;
    }
    return (
        <div className='d-flex flex-column align-items-center'>
            <div 
              className='d-flex justify-content-center w-100' 
              onClick={() => !disabled && handleTimeChange(type, +1, type === "hh" ? (time >= 24) : (time >= 59) )}
            >
              <img 
                src={!disabled ? (!disableButton('increment') ? upArrowButton : upArrowButtonDisabled): upArrowButtonDisabled} 
            height={'30px'} width={'30px'} style={{}}
            alt="arrow"
               />
            </div>
            <div 
              className={cn('w-100 d-flex justify-content-center align-items-center fs-32', styles.inputBox)}
              style={{color: !disabled? '#000':'#7B7B7B'}}
            >
                {prefix ? `0${time}` : time}
            </div>
            <div 
              className='d-flex justify-content-center w-100'
              onClick={() => !disabled && handleTimeChange(type, -1 , time <= 0)}
            > 
                <img 
                  src={!disabled ? (!disableButton('decrement') ? downArrowButton : downArrowButtonDisabled): downArrowButtonDisabled}
                  height={'30px'} width={'30px'} alt='down-arrow'
                />
            </div>
        </div>
    )
}

const KdsTimePicker = ({setTime, time, format, disableAll}) => {

    const hh = time?.hours || 0;
    const mm = time?.mins || 0;
    const ss = time?.seconds || 0;

    const handleTimeChange = (type, operator, maxValue)=>{
        if(type === 'hh') {
          (!maxValue && !disableAll) && setTime((prev) => ({...prev, hours:(prev?.hours + operator)}))
        }
        if(type === 'mm'){
            (!maxValue && !disableAll) && setTime((prev) => ({...prev, mins:(prev?.mins + operator)}))
        }
        else if(type === 'ss'){
          (!maxValue && !disableAll) && setTime((prev) => ({...prev, seconds:(prev?.seconds + operator)}))
        }
    }

    return (
        <div className='d-flex justify-content-center align-items-center'>
            <div className='w-20'>
                <TimeInputBox 
                  type='hh' 
                  disabled={!format?.toLowerCase()?.includes('hh') || disableAll}
                  handleTimeChange={handleTimeChange} time={hh} maxHour={12}
                />
            </div>
            <div>
              <img src={timerColon} height={'30px'} width={'30px'} alt="timer" />
            </div>
            <div className='w-20'>
                <TimeInputBox 
                  type='mm'
                  disabled={!format?.toLowerCase()?.includes('mm') || disableAll}
                  handleTimeChange={handleTimeChange} time={mm}
                />
            </div>
            <div>
              <img src={timerColon} height={'30px'} width={'30px'} alt="timer" />
            </div>
            <div className='w-20'>
                <TimeInputBox 
                  type='ss'
                  disabled={!format?.toLowerCase()?.includes('ss') || disableAll}
                  handleTimeChange={handleTimeChange} time={ss}
                />
            </div>
        </div>
    )
}

export default KdsTimePicker;